<template>
  <select v-model="selected">
    <option></option>
    <option
      v-for="(name, code) of studentStatuses"
      :value="code"
      :key="code">
        {{ name }}
    </option>
  </select>
</template>

<script lang="ts">
import { StudentStatus, studentStatusCode } from '@/store/students/types'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class StudentStatusInput extends Vue {
  @Prop() value!: studentStatusCode

  private studentStatuses = StudentStatus

  private get selected(): studentStatusCode {
    return this.value
  }

  private set selected(code: studentStatusCode) {
    this.$emit('input', code)
  }
}
</script>

<style scoped>
  select {
    padding: 5px;
    border: 1px solid #AAAFB6;
    border-radius: 30px;
    width: 100%;
  }
</style>
